module.exports = __webpack_public_path__ + "img/hotdocs.0d687199.png";